<template>
  <div class="root">
    <div class="statics-container">
      <div :span="7" class="statics-field-container">
        <div class="number">{{ total }}</div>
        <div class="description">Total</div>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="statics-field-container">
        <div class="number">{{ submitted }}</div>
        <div class="description">Submitted</div>
      </div>
      <el-divider class="divider" direction="vertical"></el-divider>
      <div class="statics-field-container">
        <div class="number">{{ corrected }}</div>
        <div class="description">Corrected</div>
      </div>
    </div>
    <div class="progress-container">
      <div class="progress-field-container">
        <el-progress type="circle" :percentage="submitProgress" :status="submitProgress===100?'success':undefined"></el-progress>
        <div class="description">Submitted</div>
      </div>
      <div class="progress-field-container">
        <el-progress type="circle" :percentage="correctedProgress" :status="correctedProgress===100?'success':undefined"></el-progress>
        <div class="description">Corrected</div>
      </div>
    </div>
    <el-button type="primary" class="button" @click="viewAnswers">View Student Answers</el-button>
  </div>
</template>

<script>
export default {
  name: "HomeworkStatisticsCard",
  props: {
    total: Number,
    submitted: Number,
    corrected: Number
  },
  computed: {
    submitProgress() {
      return this.total ? Math.floor((this.submitted * 100) / this.total) : 0;
    },
    correctedProgress() {
      return this.total ? Math.floor((this.corrected * 100) / this.total) : 0;
    }
  },
  methods: {
    viewAnswers() {
      const { class_id, homework_id } = this.$route.params;
      this.$router.push(`/class/${class_id}/homeworks/${homework_id}/answers`);
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  text-align: center;
}
.statics-container {
  margin-bottom: 24px;
  display: flex;
  align-items: stretch;
  .statics-field-container {
    flex: 1;
    display: inline-block;
    text-align: center;
    .number {
      font-size: 36px;
      font-weight: 700;
    }
    .description {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.25);
    }
  }
  .divider {
    height: auto;
  }
}
.progress-container {
  display: flex;
  justify-content: space-around;
  margin-bottom: 24px;
  .progress-field-container {
    flex: 1;
    text-align: center;
    .description {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.25);
    }
  }
}
.button {
  float: right;
}
</style>